// extracted by mini-css-extract-plugin
module.exports = {"CategoryWrapper":"subCategory_CategoryWrapper__2wiCM","CategoryKeywords":"subCategory_CategoryKeywords__59mX5"};